import * as React from 'react';
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface ConnectionStatus {
    isConnected: boolean;
    error?: string;
    details?: any;
}

export const SupabaseConnectionTest = () => {
    const [status, setStatus] = useState<ConnectionStatus>({ isConnected: false });

    useEffect(() => {
        const testConnection = async () => {
            try {
                console.log('🔄 Testing Supabase connection...');

                // Test de connexion simple sans requête de données
                // Juste vérifier que le client Supabase est initialisé
                const { data: { session: _session }, error } = await supabase.auth.getSession();
                
                if (error) {
                    console.error('🚨 Supabase auth issues detected:', error);
                    setStatus({
                        isConnected: false,
                        error: error.message,
                        details: error
                    });
                } else {
                    console.log('✅ Supabase connection successful');
                    setStatus({ isConnected: true });
                }
            } catch (err) {
                console.error('❌ Connection test failed:', err);
                setStatus({
                    isConnected: false,
                    error: 'Connection test failed',
                    details: err
                });
            }
        };

        testConnection();
    }, []);

    // Ne rien afficher si tout va bien
    if (status.isConnected) {
        return null;
    }

    // Afficher l'erreur seulement en développement
    if (process.env.NODE_ENV === 'development' && status.error) {
        return (
            <div className="fixed top-4 right-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded z-50">
                <strong className="font-bold">Supabase Connection Error:</strong>
                <span className="block sm:inline"> {status.error}</span>
            </div>
        );
    }

    return null;
};